import React from 'react';
import { Avatar as AntAvatar, AvatarProps, Tooltip } from 'antd';

export interface IAvatarProps extends AvatarProps {
  color?: string;
  user?: string;
  fontSize?: number | string;
}

export const getInitials = (name: string | undefined): string => {
  if (!name) return '';
  return name
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase();
};

const PALETTE = [
  '#F56A00',
  '#7265E6',
  '#FFBF00',
  '#00A2AE',
  '#87D068',
  '#108EE9',
  '#E6536A',
  '#6DA1E0',
  '#4BAD8D',
  '#A855F7',
];

export const getAvatarColor = (name: string): string => {
  const hash = name.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return PALETTE[hash % PALETTE.length];
};

const Avatar: React.FC<IAvatarProps> = ({
  gap,
  icon,
  shape,
  size,
  src,
  style,
  color,
  user,
  fontSize = 20,
}) => {
  const effectiveColor = color ?? (user ? getAvatarColor(user) : undefined);

  const fontSizeParsed =
    typeof fontSize === 'string' ? fontSize : `${fontSize}px`;

  return (
    <Tooltip title={user}>
      <AntAvatar
        style={{
          ...style,
          backgroundColor: effectiveColor ? `${effectiveColor}33` : undefined,
          color: effectiveColor,
          fontSize: fontSizeParsed,
        }}
        gap={gap}
        icon={icon}
        shape={shape}
        size={size}
        src={src}
      >
        {getInitials(user)}
      </AntAvatar>
    </Tooltip>
  );
};

export default Avatar;
